import { post, get } from '../util/crmAxios';
import { Message } from 'element-ui';
// 登录

export const userLogin = parameters => post('/Login/UserLogin', parameters)

export const getToken = parameters => post('/token', parameters);

export const getLoginUserInfo = parameters => get('/UserInfo/GetLoginUserInfo', parameters)

export const getCurrentUserMenuTree = parameters => get('/Menu/GetCurrentUserMenuTree', parameters) // 用户菜单

export const getChangePwd = parameters => post('/Login/ChangePwd', parameters) // 忘记密码
export const SendValidCode = parameters => post('/message/SendValidCode', parameters) // 发送验证吗
export const ResetPwd = parameters => post('/Login/ResetPwd', parameters) // 重置密码
export const EditUser = parameters => post('/UserInfo/EditUser', parameters) // 修改个人信息
export const UserLogOut = parameters => post('/Login/UserLogOut', parameters) // 退出登录
export const CheckIpAddress = parameters => post('/DataStru/CheckIpAddress', parameters)  // 判断是否能够拨打电话
export const GetSuspendScheduleLimit = parameters => get('/SalesGrade/GetSuspendScheduleLimit', parameters)  // 获取是否暂停排班限制
export const SuspendScheduleLimit = parameters => post('/SalesGrade/SuspendScheduleLimit', parameters)  // 是否暂停排班限制
export const GetUserNameLoginStatus = parameters => get('/Login/GetUserNameLoginStatus', parameters) // 盘古系统登录窗口提示
